import { format } from "date-fns";

export const CustomToolbar = (toolbar) => {
    const handlePrev = () => toolbar.onNavigate("PREV");
    const handleToday = () => toolbar.onNavigate("TODAY");
    const handleNext = () => toolbar.onNavigate("NEXT");

    return (
        <div
            className="custom-toolbar"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // background: "#f3f0ff",
                padding: "10px",
                borderRadius: "8px",
            }}
        >
            {/* Navigation Buttons */}
            <div className="d-flex align-items-center gap-2 dateDayAttendence"  >
                <button
                    className="btn btn-light"
                    style={{ fontSize: "18px", marginRight: "5px" }}
                    onClick={handlePrev}
                    title="Previous month"
                >
                    ‹
                </button>

                <button
                    style={{
                        background: "#7f56da",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        marginRight: "5px",
                    }}
                    onClick={handleToday}
                >
                    Today
                </button>

                <button
                    className="btn btn-light"
                    style={{ fontSize: "18px" }}
                    onClick={handleNext}
                    title="Next month"
                >
                    ›
                </button>
            </div>

            {/* Calendar Label */}
            <span style={{ fontWeight: "bold", fontSize: "18px", color: "#4a2fa0" }}>
                {format(toolbar.date, "EEEE, dd MMMM yyyy")}
            </span>

            {/* View Switcher */}
            <div className="view-buttons" style={{ display: "flex" }}>
                {["month", "week", "day", "agenda"].map((view) => (
                    <button
                        key={view}
                        style={{
                            background: toolbar.view === view ? "#7f56da" : "#e6e0f7",
                            color: toolbar.view === view ? "white" : "#7f56da",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            fontWeight: "bold",
                            marginLeft: "5px",
                        }}
                        onClick={() => toolbar.onView(view)}
                    >
                        {view.charAt(0).toUpperCase() + view.slice(1)}
                    </button>
                ))}
            </div>
        </div>
    );
};
